import axios from "axios";
import { DEFAULT_ERROR_MESSAGE } from "../../HistoriografijaConstants";
import translateErrorMessageFromBackend from "./TranslationService";

const noRefreshClient = axios.create({
    baseURL: process.env.REACT_APP_HISTORIOGRAFIJA_BACKEND,
    timeout: 60000,
    withCredentials: true
})

export const setMessageBasedOnErrorMessage = (error) => {
    if (error.response === null || error.response === undefined ||
        error.message === null || error.message === undefined) {
        error.message = DEFAULT_ERROR_MESSAGE
    } else {
        error.message = translateErrorMessageFromBackend(error.response.data.message)
    }
}

export default noRefreshClient